import React, { useState, useEffect } from 'react';
import {STATES} from './constants';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import PeriodosScreen from './Screen';
import { Periodo, PeriodosAdapter } from '../../../../../../infraestructure/persistence/rest/PeriodosAdapter';
import { useNotifications } from '../../../../../../shared/hooks/Notifications';

export const PeriodosContainer = () => {

	const api = new PeriodosAdapter();
	const {resultError, exceptionError, launchNotification}  = useNotifications();
	let [ periodos, setPeriodos ] = useState<any>([]);
	let result: any;


	const periodosAbiertos = ():boolean =>{
		const abiertos = periodos.find((f:Periodo)=> f.estado=== STATES.abierto);
		
		return (abiertos!==undefined) ? true : false;
	}

	const getPeriodos = async (ejercicio:number) => {
		try {
			result = await api.ListarPeriodos(ejercicio);
			if(result.data && result.data!=="")
			{
				setPeriodos([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const createPeriodo = async (periodo: Periodo) => {
		try {
			const result:any = await api.CrearPeriodo(periodo);
			if(result.data && result.data!=="")
			{
				setPeriodos([ ...result.data ] || []);
				launchNotification({type:"success",title:"Creación",message:"Se ha creado una nuevo periodo."})
			}else{
				resultError()
			}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	};

	const deletePeriodo = async (periodo:Periodo) => {
		try {
			result = await api.EliminarPeriodo(periodo.periodo,periodo.año);
			if(result.data && result.data!=="")
			{
				let pos = periodos.findIndex((p: Periodo) => p.periodo === periodo.periodo && p.año === periodo.año);
				let newData = [ ...periodos ];
				newData.splice(pos, 1);
				setPeriodos([ ...newData ] || []);
				launchNotification({type:"success",title:"Eliminación",message:"Se ha eliminado un periodo."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const updatePeriodo = async (updateData: Periodo) => {
		try {
			result = await api.ModificarPeriodo(updateData);
			if(result.data && result.data!=="")
			{
				let pos = periodos.findIndex((p: Periodo) => p.año === updateData.año && p.periodo === updateData.periodo);
				let newData = [ ...periodos ];
				newData[pos] = result.data[0];
				setPeriodos([ ...newData ] || []);
				launchNotification({type:"success",title:"Modificación",message:"Se ha modificado un periodo."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const updateState = async (periodo: Periodo, nuevoEstado: string) => {
		
		 const hayAbiertos:boolean = nuevoEstado === STATES.abierto ? periodosAbiertos() : false;

		 if(hayAbiertos){
		 	launchNotification({type:"warning",title:"Abrir Periodo",message:"Ya hay un periodo abierto."})
		 }else{
		 	try {
				result = await api.ModificarEstadoPeriodo(periodo, nuevoEstado);
				if(result.data && result.data!=="")
				{
					let pos = periodos.findIndex((p: Periodo) => p.año === periodo.año && p.periodo === periodo.periodo);
					let newData = [ ...periodos ];
					newData[pos] = result.data[0];
					setPeriodos([ ...newData ] || []);
					launchNotification({type:"success",title:"Modificación",message:"Se ha modificado el estado de un periodo."})
				}else{resultError()}
			} catch (error) {
				let exception = ServerErrorMessage(error);
				exceptionError(exception)
			}
		 }
	};

	return (
		<>
		<PeriodosScreen
			data={periodos}
			handleFilter={getPeriodos}
			handleCreate={createPeriodo}
			handleRemove={deletePeriodo}
			handleUpdate={updatePeriodo}
			handleOpen={updateState}
		/>
		</>
	);
};

export default PeriodosContainer;
